(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["illu-dismantled"] && !Shopify.designMode) return;
  try {
    const swiper = new Swiper('.illu_dismantled .swiper-container', {
    slidesPerView: 1.3,
    spaceBetween: 21,
  })
  } catch(e) { console.error(e); }
})();

})();
